<template lang="html">
    <div>
        <input class="input" id="date-picker" type="date">
    </div>
</template>

<script>
import flatpickr from 'flatpickr'

export default {
  name: 'date-picker',
  data () {
    return {
      datePicker: {},
      dates: [],
      options: {
        altInput: true,
        maxDate: 'today',
        mode: 'range',
        defaultDate: [
          'today',
          'today'
        ],
        onChange: function (selectedDates, dateStr, instance) {
          this.dates = selectedDates
          this.updateDate()
        }.bind(this)
      }
    }
  },

  mounted () {
    this.datePicker = flatpickr('#date-picker', this.options)
    this.dates = this.datePicker.selectedDates
    this.updateDate()
  },

  methods: {
    updateDate () {
      this.$store.commit('setDateRange', this.dates)
    }
  }

}
</script>

<style lang="scss">
    @import "node_modules/flatpickr/dist/themes/dark";
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DatePicker.vue